import type { FC } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@ui/Select";
import { cn } from "@/utils/tailwind";
import { NoSelectOptionsAvailable } from "./PaginatedSelect";

type SelectOption = {
  value: string;
  label: string;
};

export type FieldSelectProps = {
  values: SelectOption[];
  value?: string;
  isError: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
  className?: string;
  dataTest?: string;
};

export const FieldSelect: FC<FieldSelectProps> = ({
  values,
  value,
  onChange,
  className,
  disabled,
  isError,
  dataTest = "",
}) => {
  return (
    <Select onValueChange={onChange} value={value ?? ""}>
      <SelectTrigger
        className={cn(isError && "border-destructive", className)}
        disabled={disabled}
        data-test={dataTest}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {values.length === 0 ? (
          <NoSelectOptionsAvailable />
        ) : (
          values.map(opt => (
            <SelectItem
              key={opt.value}
              value={opt.value}
              data-test={`${dataTest}-option-${opt.value}`}
            >
              {opt.label}
            </SelectItem>
          ))
        )}
      </SelectContent>
    </Select>
  );
};
